import { FormField as CredentialsFormField, type Credentials } from "../Credentials";

export type SignInCredentials = Credentials;

export class FormField extends CredentialsFormField {
    public static Password = 'password';
};
